import { render, staticRenderFns } from "./user-view.vue?vue&type=template&id=7b5ef584&"
import script from "./user-view.vue?vue&type=script&lang=js&"
export * from "./user-view.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports